import { useQuery } from '@tanstack/react-query';
import { queryAircrafts } from '../../apiNew';
import { Aircraft } from '../../../models/aircraft';

const useQueryGetAllAircraft = (): { data: Aircraft[]; isFetching: boolean } => {

  const { data, isFetching } = useQuery({
    queryKey: ['allAircraft'],
    queryFn: () => queryAircrafts(),
    refetchOnWindowFocus: false,
    staleTime: 30000,
  });

  return { data: data?.data, isFetching };
};

export default useQueryGetAllAircraft;
